<template>
  <div
    id="container"
    style="display:none;"
  >
    <!-- <div class='pdf-page'> -->
    <canvas id="the-canvas"></canvas>
    <div
      class="foot"
      v-if='pdfDoc'
    >
      <div
        class='left'
        v-if="pageNum>1"
        @click="onPrevPage"
      >上一页</div>
      <div
        class='right'
        v-if="pageNum<pdfDoc.numPages"
        @click="onNextPage"
      >下一页</div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
/* eslint-disable */
import PDFJS from "pdfjs-dist";
import store from "../../store";

export default {
  data() {
    return {
      pdfDoc: null,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      scale: 2
    };
  },
  methods: {
    showPDF(url) {
      PDFJS.getDocument(url).then(pdf => {
        document.querySelector("#container").style.display = "block";
        this.pdfDoc = pdf;
        this.renderPage(1);
      });
    },
    renderPage(num) {
      store.state.loadingFlag = false;
      this.pageRendering = true;
      let _this = this;
      this.pdfDoc.getPage(num).then(function(page) {
        var viewport = page.getViewport(_this.scale);
        let canvas = document.getElementById("the-canvas");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: canvas.getContext("2d"),
          viewport: viewport
        };
        var renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(function() {
          _this.pageRendering = false;
          if (_this.pageNumPending !== null) {
            // New page rendering is pending
            this.renderPage(_this.pageNumPending);
            _this.pageNumPending = null;
          }
        });
      });
    },
    queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
    onPrevPage() {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--;
      this.queueRenderPage(this.pageNum);
    },
    onNextPage() {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return;
      }
      this.pageNum++;
      this.queueRenderPage(this.pageNum);
    }
  },

  /**
   * 该组件卸载时，移除scrollToTop事件
   */ destroyed() {
    this.PDFFlag = false;
  }
};
</script>
 <style lang="less" scoped>
#container {
  background-color: rgba(0, 0, 0, 0.75);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  padding: 5px;
  #the-canvas {
    width: 100%;
  }
}

.foot {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  > div {
    padding-left: 30px;
    padding-right: 30px;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    color: #fff;
    background-color: #4090fe;
    border-radius: 6px;
  }
}
</style>
